export default __webpack_public_path__ + "static/media/plate_bcr.4e55cd8b.svg";